import React, { useState, useEffect } from 'react';
import { TextField, Select, MenuItem, InputLabel, FormControl, Grid } from '@mui/material';
import { sendAPIRequest } from 'helpers';
const SurveyElements = ({ surveyMissionId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = React.useState({
    id: '',
    name: '',
    email: '',
    country: '',
    language: '',
  });

  useEffect(() => {
    const getSingleSurveyData = async () => {
      setIsLoading(true);
      try {
        const data = await sendAPIRequest(`/api/pvsa/survey/survey-by-id?id=${surveyMissionId ?? ''}`);
        const response = await data.json();
        setFormData({
          id: response.data.mission_id || '',
          name: response.data.delegate_name || '',
          email: response.data.email,
          country: response.data.country_name || '',
          language: response.data.language || 'English',
        });
      } catch (e) {
        console.error("Error fetching survey data:", e);
      } finally {
        setIsLoading(false);
      }
    };
    if (surveyMissionId) getSingleSurveyData();
  }, [surveyMissionId]);

  return (
    <Grid container spacing={2} sx={{ padding: 2, backgroundColor: '#f5f5f5' }}>
      <Grid item xs={12} sm={2}>
        <TextField
          label="ID"
          name="id"
          value={formData.id}
          variant="outlined"
          fullWidth
          disabled
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Name"
          name="name"
          value={formData.name}
          variant="outlined"
          fullWidth
          disabled
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Email"
          name="email"
          value={formData.email}
          variant="outlined"
          fullWidth
          disabled
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <TextField
          label="Country"
          name="country"
          value={formData.country}
          variant="outlined"
          fullWidth
          disabled
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <TextField
          label="Language"
          name="language"
          value={formData.language}
          variant="outlined"
          fullWidth
          disabled
        />
      </Grid>
    </Grid>
  );
};

export default SurveyElements;